<template>
	<v-dialog v-model="importPropertiesModal" transition="scroll-x-reverse-transition" max-width="900">
		<template #activator="{ on, attrs }">
			<v-btn color="secondary"
				elevation="0"
				small
				v-bind="attrs"
				v-on="on">
				<v-icon left class="white--text">mdi-table-arrow-left</v-icon>
				Import Properties
			</v-btn>
		</template>
		<template #default>
			<v-card>
				<v-card-title>
					<div>Import Properties</div>
					<v-icon right class="ml-auto theme--dark" @click="resetImport">mdi-close</v-icon>
				</v-card-title>
				<v-divider class="mb-5" />
				<v-card-text>
					<template v-if="! parsed">
						<p>To get started, select a file to import and continue.</p>
						<v-file-input
							v-model="importFile"
							accept="text/csv,application/vnd.ms-excel"
							counter
							outlined
							placeholder="Select a file..."
							persistent-placeholder
							truncate-length="45"></v-file-input>
					</template>
					<template v-else>
						<v-alert color="success">
							<span class="white--text">
								<strong>Great!</strong> Found {{ length(content) }} records to import.
								Please select a data field to configure how to import the data.
							</span>
						</v-alert>

						<v-card v-if="content.meta.fields" outlined>
							<v-simple-table>
								<thead>
									<tr>
										<th class="text-left">
											Column
										</th>
										<th class="text-left">
											Import Into
										</th>
									</tr>
								</thead>
								<tbody>
									<template>
										<tr v-for="(field, fieldKey) in form.map" :key="`field-` + fieldKey">
											<td>{{ fieldKey }}</td>
											<td>
												<v-select
													v-model="form.map[fieldKey]"
													:items="availableFields"
													placeholder="Select property field (optional)"
													persistent-placeholder
													clearable
													outlined
													hide-details />
											</td>
										</tr>
									</template>
								</tbody>
							</v-simple-table>
							<v-card-actions class="justify-end">
								<p class="ma-0 mr-2 grey--text text--darken-2">Leave import selection blank to ignore the column.</p>
							</v-card-actions>
						</v-card>
					</template>
				</v-card-text>
				<v-divider />
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="red" @click="resetImport">Cancel</v-btn>
					<v-btn
						v-if="!parsed"
						large
						color="primary"
						:disabled="!importFile"
						@click="parseFile">
						Continue
					</v-btn>
					<v-btn
						v-else
						large
						color="success"
						:disabled="isInvalid"
						@click="handleSubmit">
						Import Properties
					</v-btn>
				</v-card-actions>
			</v-card>
		</template>
	</v-dialog>
</template>
<script>
import Papa from 'papaparse'

export default {
	props: {
		project: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			importPropertiesModal: false,
			importFile: null,
			content: {},
			parsed: false,
			availableFields: [
				{ value: 'sector', text: 'Sector'},
				{ value: 'activity', text: 'Activity'},
				{ value: 'address_1', text: 'Address Line 1'},
				{ value: 'address_2', text: 'Address Line 2'},
				{ value: 'city', text: 'City'},
				{ value: 'state_id', text: 'State'},
				{ value: 'zipcode', text: 'Zip Code'},
				{ value: 'type', text: 'Property Type'},
				{ value: 'asset_relationship', text: 'Asset Relationship'},
				{ value: 'loan_seller', text: 'Loan Seller'},
				{ value: 'pool_asset_number', text: 'Pool Asset Number'},
				{ value: 'upb', text: 'UPB'},
				{ value: 'is_locked', text: 'Locked'},
				{ value: 'property_risk', text: 'Property Risk'},
				{ value: 'investor_risk', text: 'Investor Risk'},
				{ value: 'total_expected_cost', text: 'Total Expected Cost'}
			],
			form: this.$inertia.form({
				map: {},
				payload: []
			})
		}
	},
	computed: {
		isInvalid () {
			if (!this.length(this.form.map) || !this.length(this.form.payload)) {
				return true
			}

			const mapValues = Object.values(this.form.map)
			if (! mapValues.includes('address_1')) {
				return true
			}

			return false
		}
	},
	methods: {
		parseFile () {
			// https://www.papaparse.com/docs#config
			Papa.parse( this.importFile, {
				header: true,
				skipEmptyLines: true,
				complete: function ( results ) {
					if (results.hasOwnProperty('data')) {
						this.$set(this.form, 'payload', _.cloneDeep(results.data))
					}

					let map = {}
					if (results.hasOwnProperty('meta') && results.meta.hasOwnProperty('fields')) {
						for (const fieldsKey in results.meta.fields) {
							map[results.meta.fields[fieldsKey]] = null
						}
					}

					this.$set(this.form, 'map', map)
					this.content = results
					this.parsed = true
				}.bind(this)
			} )
		},

		handleSubmit () {
			const route = this.route('properties.import', { project: this.project })
			this.form.post(route, {
				onSuccess: () => this.resetImport()
			})
		},

		resetImport () {
			this.importPropertiesModal = false
			this.form.reset()
			this.parsed = false
			this.content = {}
			this.importFile = null
		}
	}
}
</script>
